// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportErrorPopup.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import Popup from 'share/components/controls/CommonPopup/Izenda.Popup';
import ScrollBox from 'share/components/controls/Izenda.ScrollBox';
import connect from 'share/enhancers/Izenda.Connect';

@connect()
export default class ImportErrorPopup extends Component {
  onClosing = () => {
    this.props.store.hideErrorMessages();
    this.props.onReject();
  };

  renderMessages = (messages: Array<string>): any => {
    return (
      <ScrollBox autoHeight>
        {messages.map((item, index) => <p key={index}>{item}</p>)}
      </ScrollBox>
    );
  };

  render() {
    const { localization, messages } = this.props;

    return (
      <Popup visible onClosing={this.onClosing} type="none" autoClose={false} sizeClass="modal-lg">
        <Popup.Header title={localization.getText('IMPORT_LABEL_VALIDATION_ERRORS_FILES')} />
        <Popup.Body>{this.renderMessages(messages)}</Popup.Body>
        <Popup.Footer>
          <Popup.ConfirmationButton key="accept" type="accept">
            {localization.getText('COMMON_LABEL_OK')}
          </Popup.ConfirmationButton>
        </Popup.Footer>
      </Popup>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/Import/Popup/Izenda.ImportErrorPopup.js